import TOP_BARS from '@/utils/topBars';
export default [
  /**
   * @function /student/manage/capstone
   * @param {Component} Manager /views/student/Manager/Capstone
   * @param {Name} pathname student-manage-capstone
   */
  {
    path: '/student/manage/capstone',
    name: 'student-manage-capstone',
    meta: {
      title: 'Capstone'
    },
    component: () => import('@/views/student/Manager/Capstone')
  },
  /**
   * @description 老师端管理
   * @function /student/capstone/detail/:id/:period
   * @param {Component} CapstonePro @/views/student/Manager/Capstone/Detail
   * @param {Name} pathname student-capstone-detail
   */
  {
    path: '/student/capstone/detail/:id/:period',
    name: 'student-capstone-detail',
    meta: {
      title: 'Capstone'
    },
    component: () => import('@/views/student/Manager/Capstone/Detail')
  },
  /**
   * @description 老师端管理
   * @function /student/capstone-expo
   * @param {Component} CapstoneExpo @/views/student/Manager/Capstone/Expo
   * @param {Name} pathname student-capstone-expo
   */
  {
    path: '/student/capstone-expo',
    name: 'student-capstone-expo',
    meta: {
      title: 'CapstoneExpo'
    },
    component: () => import('@/views/student/Manager/Capstone/Expo')
  },
  /**
   * @description 学生端 -- 独立的学生端页面
   * @function /student/manage/courses
   * @param {Component} Manager /views/student/Manager/courses
   * @param {Name} pathname student-manage-courses
   */
  {
    path: '/student/manage/courses',
    name: 'student-manage-courses',
    meta: {
      title: '学生'
    },
    component: () => import('@/views/student/Manager/Independent')
  },
  /**
   * @description 学生端 -- CPSeminar 列表页面
   * @function /student/manage/courses/:cp
   * @param {Component} Manager /views/student/Manager/courses/
   * @param {Name} pathname student-manage-courses
   */
  {
    path: '/student/manage/courses/:type',
    name: 'student-manage-courses-filter',
    meta: {
      title: '学生'
    },
    component: () => import('@/views/student/Manager/Independent')
  },
  /**
   * @description 学生端Seminar 列表
   * @function /student/manage/list
   * @param {Component} CourseList /views/student/Manager/CourseList
   * @param {Name} pathname student-manage-list
   */
  {
    path: '/student/manage/list',
    name: 'student-manage-list',
    meta: {
      title: 'Seminar 列表'
    },
    component: () => import('@/views/student/Manager/CourseList')
  },
  /**
   * @description 学生端Seminar 详情
   * @function /student/manage/course-detail
   * @param {Component} CourseDetail /views/student/Manager/CourseDetail
   * @param {Name} pathname student-manage-detail
   */
  {
    path: '/student/manage/course-detail/:course_id/:period',
    name: 'student-manage-detail',
    meta: {
      title: '课程详情'
    },
    component: () => import('@/views/student/Manager/CourseDetail')
  },
  /**
   * @description 学生端从全部课程里进入的 Seminar 详情
   * @function /student/manage/course-detail
   * @param {Component} CourseDetail /views/student/Manager/CourseDetail
   * @param {Name} pathname student-manage-detail
   */
  {
    path: '/student/manage/course-detail/:course_id',
    name: 'student-manage-detail-course',
    meta: {
      title: 'Seminar 详情'
    },
    component: () => import('@/views/student/Manager/CourseDetail')
  },
  {
    path: '/student/manage/cornerstone-workshop',
    name: 'student-manage-cornerstone-workshop',
    meta: {
      title: 'Cornerstone Workshop',
      topBar: TOP_BARS.TEXT_BLOCK
    },
    component: () => import('@/views/student/Manager/CornerstoneWorkshop')
  },
  /**
   * @desc 学生端 电台
   * @function /student/manage/broadcasting-station
   * @param {Component} BroadcastingStation views/student/Manager/Events/BroadcastingStation
   * @param {Name} pathname student-broadcasting-station
   */
  {
    path: '/student/manage/broadcasting-station',
    name: 'student-broadcasting-station',
    meta: {
      title: '电台'
    },
    component: () => import('@/views/student/Manager/Events/Hsylcer')
  },
  /**
   * @description house cup rules
   * @function /student/manage/house/rules
   * @param {Component} Rule /views/student/Manager/House/HouseCupRule
   * @param {Name} pathname student-manage-house-rules
   */
  {
    path: '/student/manage/house/rules',
    name: 'student-manage-house-rules',
    meta: {
      title: 'House Cup Rules'
    },
    component: () => import('@/views/student/Manager/House/HouseCupRule')
  },
  /**
   * @description 成绩说明
   * @function /student/manage/grade/grade-explain
   * @param {Component} GradeExplain /views/student/Manager/Grade/GradeExplain
   * @param {Name} pathname student-manage-grade-explain
   */
  {
    path: '/student/manage/grade/grade-explain',
    name: 'student-manage-grade-explain',
    meta: {
      title: '成绩单说明'
    },
    component: () => import('@/views/student/Manager/Grade/GradeExplain')
  },
  /**
   * @description 成绩说明
   * @function /student/manage/grade/grade-query
   * @param {Component} GradeExplain /views/student/Manager/Grade/GradeQuery
   * @param {Name} pathname student-manage-grade-query
   */
  {
    path: '/student/manage/grade/grade-query',
    name: 'student-manage-grade-query',
    meta: {
      title: '成绩查询'
    },
    component: () => import('@/views/student/Manager/Grade/GradeQuery')
  },
  {
    path: '/student/manage/grade/post',
    component: () => import('@/views/student/Manager/Grade/Post'),
    children: [
      {
        path: '',
        name: 'student-manage-grade-post-list',
        component: () => import('@/views/student/Manager/Grade/Post/List')
      },
      {
        path: 'detail/:id?',
        name: 'student-manage-grade-post-detail',
        component: () => import('@/views/student/Manager/Grade/Post/Detail')
      }
    ]
  },
  {
    path: '/student/manage/certificate/post',
    component: () => import('@/views/student/Manager/Grade/Certificate'),
    children: [
      {
        path: '',
        name: 'student-manage-certificate-post-list',
        component: () => import('@/views/student/Manager/Grade/Certificate/List')
      },
      {
        path: 'detail/:id?',
        name: 'student-manage-certificate-post-detail',
        component: () => import('@/views/student/Manager/Grade/Certificate/Detail')
      }
    ]
  },
  {
    path: '/student/manage/certificate/honor',
    component: () => import('@/views/student/Manager/HonorHistory'),
  },
  {
    path: '/student/manage/recommend-letter',
    name: 'student-manage-recommend-letter',
    meta: {
      title: '推荐信'
    },
    component: () => import('@/views/student/Manager/RecommendLetter')
  },
  {
    path: '/student/manage/recommend-letter-past',
    name: 'student-manage-recommend-letter-past',
    meta: {
      title: '推荐信',
      topBar: TOP_BARS.NO_USER
    },
    component: () => import('../../views/student/Manager/RecommendLetter/Past')
  },
  /**
   * @description 学生端
   * @function /student/manage/academic-resources
   * @param {Component} Academic /views/student/Manager/Academic
   * @param {Name} pathname student-manage-academic-resources
   */
  {
    path: '/student/manage/academic-resources',
    name: 'student-manage-academic-resources',
    meta: {
      title: 'Academic Resource'
    },
    component: () => import('@/views/student/Manager/Academic')
  },
  {
    path: '/student/brain-olympics',
    name: 'student-brain-olympics',
    component: () => import('@/views/student/Manager/Olympics')
  },
  {
    path: '/student/manage/orientation',
    name: 'student-manage-orientation',
    meta: {
      title: 'HSYLC 2022 Student Orientation'
    },
    component: () => import('@/views/student/Manager/Orientation')
  },
  /**
   * @description 学生端
   * @function /student/manage/hbr
   * @param {Component} Business /views/student/Manager/Business
   * @param {Name} pathname student-manage-business
   */
  {
    path: '/student/manage/hbr',
    name: 'student-manage-hbr',
    component: () => import('@/views/student/Manager/Business')
  },
  /**
   * @description 学生端
   * @function /student/manage/writing-center
   * @param {Component} WritingCenter /views/student/Manager/WritingCenter
   * @param {Name} pathname student-writing-center
   */
  {
    path: '/student/manage/writing-center/:state?',
    name: 'student-manage-writing-center',
    component: () => import('@/views/student/Manager/WritingCenter')
  },
  /**
   * @description 学生端
   * @function /student/manage
   * @param {Component} Manager /views/student/Manager
   * @param {Name} pathname student-manage
   */
  {
    path: '/student/manage/:filter',
    name: 'student-manage-filter',
    meta: {
      title: '学生'
    },
    component: () => import('@/views/student/Manager')
  }
];
